import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from '@ontruck/orc';

const Container = styled.div`
  border-top: 1px solid var(--greyWolf);
`;

const t = {
  add_load: 'Add load with different pallet size',
};

const AddLoad = ({ onClick }) => (
  <Container>
    <Button nude skin="primary" text={t.add_load} onClick={onClick} fullWidth />
  </Container>
);

AddLoad.propTypes = {
  onClick: PropTypes.func,
};

export default AddLoad;
